import { render, staticRenderFns } from "./abilityDetail.vue?vue&type=template&id=74d2a585&scoped=true&"
import script from "./abilityDetail.vue?vue&type=script&lang=js&"
export * from "./abilityDetail.vue?vue&type=script&lang=js&"
import style0 from "./abilityDetail.vue?vue&type=style&index=0&id=74d2a585&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d2a585",
  null
  
)

export default component.exports